import Axios from 'axios';

const bodyIdParams = {
    Reservation: {
        ContactFlowId: 'ca31c473-9788-4725-9b33-782586a4ed6f',
        InstanceId: '32f1f200-1b30-454a-8f52-0441cbb4d340',
        QueueId: 'edb390b0-9881-4b19-8dc1-0cabe3f0e3ea',
    },
    Options: {
        ContactFlowId: 'b311b038-e211-4ab3-8b87-00984d60e9b1',
        InstanceId: '32f1f200-1b30-454a-8f52-0441cbb4d340',
        QueueId: '299bada8-6344-436f-80a8-877c6267a59b',
    },
    ActivityQuestions: {
        ContactFlowId: 'b311b038-e211-4ab3-8b87-00984d60e9b1',
        InstanceId: '32f1f200-1b30-454a-8f52-0441cbb4d340',
        QueueId: '299bada8-6344-436f-80a8-877c6267a59b',
    },
};

const QueryInstance = Axios.create({
    baseURL: 'https://88fjt7qdz8.execute-api.us-east-1.amazonaws.com/prod/',
    headers: {
        'X-Api-Key': 'jPdjGnzxaG93ltJIglVLQ3uKXZ1rcshJ94H9GSt7',
    },
});

const apiSendInfo = async ({ phone, firstName, lastName, email, questionType, href }) => {
    return QueryInstance.post('exec/startOutboundVoiceContact', {
        ContactFlowId: bodyIdParams[questionType].ContactFlowId,
        DestinationPhoneNumber: phone,
        InstanceId: bodyIdParams[questionType].InstanceId,
        Attributes: {
            FirstName: firstName,
            LastName: lastName,
            Email: email,
            questionType: questionType,
            InitPage: href,
        },
        QueueId: bodyIdParams[questionType].QueueId,
    });
};

export default apiSendInfo;
